/* eslint-disable no-nested-ternary */
import { useTranslate } from 'hooks/useTranslate';
import { Tooltip } from 'react-tooltip';
import { formatNumber } from 'utils/formats';

import { hasInternalView } from 'utils/showDetails';

import '../PlanSummary.scss';

function PlanSummaryPeriodsTable({
  view,
  summary,
  plansNames,
  periods,
  values,
  isFormatted = true,
}) {
  const { t } = useTranslate();

  const formatValue = (value) => (isFormatted ? formatNumber(value) : value);

  return (
    summary && (
      <div
        className={
          view === 0 || view === 1 ? 'nk-block w-100 overflow-hidden' : 'd-none'
        }
      >
        <div className="card card-bordered card-preview w-100">
          <div className="table-responsive">
            <table
              className="table table-striped nk-tb-list nk-tb-ulist cloned pos-abs bg-white border-right partner-book-table summary-plans-table"
              id="table-overlap"
            >
              <thead>
                <tr className="nk-tb-item nk-tb-head tb-tnx-head text-center table-header">
                  <th className="nk-tb-col w-200px d-block border-right">
                    &nbsp;
                  </th>
                </tr>
                <tr className="nk-tb-item nk-tb-head tb-tnx-head text-center">
                  <th className="nk-tb-col w-200px d-block table-subheader border-right">
                    {t('Plans')}
                  </th>
                </tr>
              </thead>

              <tbody>
                {Object.keys(summary.phantoms)?.map((planId) => (
                  <>
                    <tr className="nk-tb-item">
                      <td
                        id={planId}
                        className="nk-tb-col text-left w-200px d-block text-ellipsis border-none"
                      >
                        {plansNames[planId]}
                        <Tooltip anchorId={planId} place="bottom">
                          {plansNames[planId]}
                        </Tooltip>
                      </td>
                    </tr>
                  </>
                ))}

                {Object.keys(summary.stockOptions)?.map((planId, index) => (
                  <>
                    <tr className="nk-tb-item">
                      <td
                        id={planId}
                        className="nk-tb-col text-left w-200px d-block text-ellipsis border-none"
                      >
                        {plansNames[planId]}
                        <Tooltip anchorId={planId} place="bottom">
                          {plansNames[planId]}
                        </Tooltip>
                      </td>
                    </tr>
                  </>
                ))}

                {Object.keys(summary.warrants)?.map((planId, index) => (
                  <>
                    <tr className="nk-tb-item">
                      <td
                        id={planId}
                        className="nk-tb-col text-left w-200px d-block text-ellipsis"
                      >
                        {plansNames[planId]}
                        <Tooltip anchorId={planId} place="bottom">
                          {plansNames[planId]}
                        </Tooltip>
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>

            <table
              className="table table-striped nk-tb-list nk-tb-ulist text-right border-right partner-book-table summary-plans-table"
              id="periodsTable"
              style={{
                width: `${periods.length * 400 + 210}px`,
              }}
            >
              <thead>
                <tr className="nk-tb-item nk-tb-head tb-tnx-head text-center table-header">
                  <th className="nk-tb-col w-200px d-block border-right">
                    &nbsp;
                  </th>

                  {periods?.map((period) => (
                    <th
                      className="nk-tb-col border-right"
                      style={{ height: '50px !important' }}
                      colSpan={5}
                    >
                      {period}
                    </th>
                  ))}
                </tr>

                <tr className="nk-tb-item nk-tb-head tb-tnx-head text-center">
                  <th className="nk-tb-col w-200px d-block table-subheader border-right">
                    {t('Plans')}
                  </th>
                  {periods?.map(() => (
                    <>
                      <th
                        className="nk-tb-col table-subheader border-right"
                        style={{ height: '50px !important' }}
                      >
                        {t('Total')}
                      </th>
                      <th
                        className="nk-tb-col no-break table-subheader border-right"
                        style={{ height: '50px !important' }}
                      >
                        {t('AssignedUnits')}
                      </th>
                      <th
                        className="nk-tb-col no-break table-subheader border-right"
                        style={{ height: '50px !important' }}
                      >
                        {t('Vested')}
                      </th>
                      <th
                        className="nk-tb-col no-break table-subheader border-right"
                        style={{ height: '50px !important' }}
                      >
                        {t('CanceledUnits')}
                      </th>
                      <th
                        className="nk-tb-col no-break table-subheader border-right"
                        style={{ height: '50px !important' }}
                      >
                        {t('Acquired')}
                      </th>
                    </>
                  ))}
                </tr>
              </thead>

              <tbody>
                {Object.keys(summary.phantoms)?.map((planId, index) => (
                  <>
                    <tr className="nk-tb-item text-center">
                      <td
                        id={planId}
                        className="nk-tb-col vertical-align-middle text-left w-200px d-block text-ellipsis border-right"
                      >
                        {plansNames[planId]}
                        <Tooltip anchorId={planId} place="bottom">
                          {plansNames[planId]}
                        </Tooltip>
                      </td>
                      {values[planId].map((value) => (
                        <td
                          className={
                            index === 0
                              ? 'nk-tb-col vertical-align-middle text-right text-ellipsis border-right'
                              : 'nk-tb-col vertical-align-middle text-right border-right'
                          }
                          style={{ height: '50px !important' }}
                        >
                          {formatValue(value)}
                        </td>
                      ))}
                    </tr>
                  </>
                ))}

                {Object.keys(summary.stockOptions)?.map((planId, index) => (
                  <>
                    <tr className="nk-tb-item text-center">
                      <td
                        id={planId}
                        className="nk-tb-col text-left w-200px d-block text-ellipsis border-right"
                      >
                        {plansNames[planId]}
                        <Tooltip anchorId={planId} place="bottom">
                          {plansNames[planId]}
                        </Tooltip>
                      </td>
                      {values[planId].map((value) => (
                        <td
                          className={
                            index === 0
                              ? 'nk-tb-col text-right text-ellipsis border-right'
                              : 'nk-tb-col text-right border-right'
                          }
                          style={{ height: '50px !important' }}
                        >
                          {formatValue(value)}
                        </td>
                      ))}
                    </tr>
                  </>
                ))}

                {Object.keys(summary.warrants)?.map((planId, index) => (
                  <>
                    <tr className="nk-tb-item text-center">
                      <td
                        id={planId}
                        className="nk-tb-col text-left w-200px d-block text-ellipsis border-right"
                      >
                        {plansNames[planId]}
                        <Tooltip anchorId={planId} place="bottom">
                          {plansNames[planId]}
                        </Tooltip>
                      </td>
                      {values[planId].map((value) => (
                        <td
                          className={
                            index === 0
                              ? 'nk-tb-col text-right text-ellipsis border-right'
                              : 'nk-tb-col text-right border-right'
                          }
                          style={{ height: '50px !important' }}
                        >
                          {formatValue(value)}
                        </td>
                      ))}
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  );
}

export default PlanSummaryPeriodsTable;
